import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconRewind"><Path d="M9.56999 18.6136C10.5537 19.3902 11.9995 18.6895 11.9995 17.4362V14.2158L17.57 18.6136C18.5536 19.3901 19.9995 18.6895 19.9995 17.4362V6.56335C19.9995 5.31008 18.5536 4.60944 17.57 5.38602L11.9995 9.78381V6.56334C11.9995 5.31008 10.5536 4.60945 9.56999 5.38602L2.68382 10.8225C1.9231 11.423 1.92311 12.5766 2.68382 13.1771L9.56999 18.6136Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRewind;
